import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import {
  ConversionSuiteStatusesContext,
  isConversionFeatureLocked,
} from "../../redo-suite/conversion-cloud";
import { useScheduleDemo } from "../common/schedule-demo-provider";

/**
 * Returns whether a feature is locked for the current team and a click handler
 * that opens the schedule-a-call flow. Frontend presentation only — does not
 * stop storefront features.
 *
 * Callers should honor `shouldHide` (under $3k estimated deal size) before
 * rendering the lock-icon treatment for `locked`.
 */
export function useConversionLockedAction(
  buttonLocation: ScheduleDemoButtonLocation,
  feature: ConversionFeature,
) {
  const { lockedFeatures, lockPresentation, lockPresentationResolved } =
    useRequiredContext(ConversionSuiteStatusesContext);
  const { handleScheduleDemo } = useScheduleDemo();

  const locked = isConversionFeatureLocked(feature, lockedFeatures);
  // Only hide after deal-size is resolved — otherwise ≥$3k teams flash
  // missing nav items while the order-count RPC is in flight.
  const shouldHide =
    locked && lockPresentation === "hidden" && lockPresentationResolved;

  const onLockedClick = useHandler(async () => {
    await handleScheduleDemo({ buttonLocation });
  });

  return { locked, shouldHide, onLockedClick };
}
